export default __webpack_public_path__ + "static/media/5.c712c5fd.jpg";